import { render, staticRenderFns } from "./ColorPickerInput.vue?vue&type=template&id=65c96cfc&scoped=true&"
import script from "./ColorPickerInput.vue?vue&type=script&lang=js&"
export * from "./ColorPickerInput.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerInput.vue?vue&type=style&index=0&id=65c96cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../HistomicsUI/histomicsui/web_client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c96cfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/HistomicsUI/histomicsui/web_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c96cfc')) {
      api.createRecord('65c96cfc', component.options)
    } else {
      api.reload('65c96cfc', component.options)
    }
    module.hot.accept("./ColorPickerInput.vue?vue&type=template&id=65c96cfc&scoped=true&", function () {
      api.rerender('65c96cfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@girder/histomicsui/vue/components/ColorPickerInput.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./~/@girder/histomicsui/vue/components/ColorPickerInput.vue
// module id = 60
// module chunks = 0